<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M32 6.5c-6.72 0-12.167 5.447-12.167 12.167v6.5h-6.5a1.5 1.5 0 00-1.5 1.5V56a1.5 1.5 0 001.5 1.5h37.334a1.5 1.5 0 001.5-1.5V26.667a1.5 1.5 0 00-1.5-1.5h-6.5v-6.5C44.167 11.947 38.719 6.5 32 6.5zm9.167 18.667v-6.5a9.167 9.167 0 10-18.334 0v6.5h18.334zM14.833 54.5V28.167h34.334V54.5H14.833z"/></svg>